import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ProductFinePrintStyles;
    finePrint?: string;
}

type Props = OwnProps;

export interface ProductFinePrintStyles {
    wrapper?: InjectableCss;
    finePrint?: TypographyProps;
}

export const productFinePrintStyles: ProductFinePrintStyles = {
    wrapper: {
        css: css`
            margin: 8px 0px 24px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
            css`
                margin: 4px 0px 16px;
            `,
            css`
                margin: 4px 0px 16px;
            `,
            null,
            null,
            null,
        ])}
        `,
    },
    finePrint: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
        `,
    },
};

const styles= productFinePrintStyles;

const ProductFinePrint: FC<Props> = ({ finePrint }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.finePrint}>{finePrint}</StyledWrapper>
        </StyledWrapper>
    );
};

export default ProductFinePrint;
